import { apiRequest } from './api';

export const auditService = {
    getAuditLogs: async (params = {}) => {
        try {
            const response = await apiRequest.get('/audit-logs', { params });
            return response.data.data;
        } catch (error) {
            throw new Error(error.message || 'Failed to fetch audit logs');
        }
    }
};

